module.exports = __webpack_public_path__ + "static/media/charactor_kagerou.aa32de7d.png";